/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { MenuItem as RcMenuItem } from "rc-menu";

export const MenuItem = RcMenuItem;
